import React from 'react';
import { Marquee } from './Marquee';
export function Hero() {
  return <section className="w-full bg-midnight min-h-screen flex flex-col" data-id="element-160">
      <Marquee data-id="element-161" />

      <div className="flex-1 flex flex-col justify-center px-4 md:px-8 lg:px-16 py-16 md:py-24 max-w-7xl mx-auto w-full" data-id="element-162">
        <h1 className="font-heading font-bold text-ivory uppercase leading-none tracking-tight text-5xl sm:text-7xl md:text-8xl lg:text-[10rem] xl:text-[12rem]" data-id="element-163">
          XENO
          <br data-id="element-164" />
          <span className="text-crimson" data-id="element-165">JOUEUR</span>
        </h1>

        <p className="font-body text-ivory/80 text-lg md:text-2xl mt-8 md:mt-12 max-w-3xl leading-relaxed" data-id="element-166">
          AI-Powered iGaming Localization.
          <br data-id="element-167" />
          <span className="text-saffron font-semibold" data-id="element-168">
            Cultural Compliance at Machine Speed.
          </span>
        </p>

        <div className="mt-12 md:mt-16 border-l-4 border-crimson pl-6 md:pl-8" data-id="element-169">
          <p className="font-heading font-bold text-ivory text-2xl sm:text-3xl md:text-5xl lg:text-6xl uppercase leading-tight tracking-tight" data-id="element-170">
            50+ jurisdictions.
            <br data-id="element-171" />
            30+ languages.
            <br data-id="element-172" />
            <span className="text-emerald" data-id="element-173">Zero margin for error.</span>
          </p>
        </div>
      </div>
    </section>;
}